import { render } from "./app-sidebar.vue?vue&type=template&id=8e3c538c"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/layout/app-sidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8e3c538c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8e3c538c', __exports__)) {
    console.log('reload')
    api.reload('8e3c538c', __exports__)
  }
  
  module.hot.accept("./app-sidebar.vue?vue&type=template&id=8e3c538c", () => {
    console.log('re-render')
    api.rerender('8e3c538c', render)
  })

}


export default __exports__